<template>
    <div>
      <div>
        <div style="display: flex; flex-direction: column; align-items: center;">
        <div style="margin-top: 2.25rem;font-size: 2rem;line-height: 2rem;font-weight: bold;color: rgb(182, 45, 46);">
        {{ $t('other.contact') }}
        </div>
        <div style="display: flex; margin-top: 0.5rem; margin-bottom: 5rem">
        <span style="width: 1rem;height: 1rem;background: rgb(182, 45, 46);border-radius: 50%;margin: 0px 0.5rem;"></span>
        <span style="width: 1rem;height: 1rem;background: rgb(222, 89, 52);border-radius: 50%;margin: 0px 0.5rem;"></span>
        <span style="width: 1rem;height: 1rem;background: rgb(241, 170, 85);border-radius: 50%;margin: 0px 0.5rem;"></span>
      </div>
        <div style="margin-bottom: 2rem;font-size: 1.15rem;font-weight: bold;padding: 10px;">
        {{ $t('contact.desc') }}
        </div>
      </div>
        <div class="col-sm-left-10" style="margin-bottom: 2rem;"><div style="padding:1rem;">
          <img :src="require('@/assets/images/contact-whatsapp.png')" style="width:2rem;vertical-align: middle;margin-right:1rem;" />
          <a
              href="https://api.whatsapp.com/send/?phone=85260195577&text&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              class="whatsapp-contact"
          >
            <span class="whatsapp-number">+852 6019 5577</span>
          </a>
        </div>
        <div style="padding:1rem;"><img :src="require('@/assets/images/contact-email.png')" style="width:2rem;vertical-align: middle;margin-right:1rem;" />

          <a
              href="mailto:support@mathconceptonline.com"
              class="email-contact"
          >
            <span class="email-address">support@mathconceptonline.com</span>
          </a>
        </div>
        <div style="padding:1rem;">
          <img :src="require('@/assets/images/contact-phone.png')" style="width:2rem;vertical-align: middle;margin-right:1rem;" />

          <a
              href="tel:+85227881188"
              class="phone-contact"
          >
            <span class="phone-number">+852 2788 1188</span>
          </a>
        </div><br><br><br>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            facebook:'https://www.facebook.com',
            content:""
        };
    },
    watch: {

    },
    created() {
        window.onFacebook=this.onFacebook

    },
    methods: {
        onFacebook(){
            window.open(this.facebook, "_blank");
        },

    },
};
</script>

<style lang="scss" scoped>
/*
.contact-box{
    margin-left:42vw;
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .contact-box{
        margin-left:0;
    }
}*/
</style>